import React from 'react';
import { ErrorBoundary as ReactErrorBoundary } from 'react-error-boundary';

const fallbackRender = ({ error, resetErrorBoundary }) => (
  <div className="error-boundary" role="alert">
    <h2>Something went wrong</h2>
    <p>{error?.message || 'Unexpected application error.'}</p>
    <button type="button" onClick={resetErrorBoundary}>
      Retry
    </button>
  </div>
);

/**
 * Functional error boundary wrapper using react-error-boundary.
 */
export const ErrorBoundary = ({ children }) => (
  <ReactErrorBoundary fallbackRender={fallbackRender}>{children}</ReactErrorBoundary>
);

